import contentStyles from './Content.module.scss';

export { LayoutLegal } from './LayoutLegal';

export { contentStyles };
